export default __webpack_public_path__ + "static/media/lms_homepg_500.ad46a275.jpg";